module.exports = require("chalk");


//////////////////
// WEBPACK FOOTER
// external "chalk"
// module id = 5
// module chunks = 0